/**
 * Documentación:
 * 
 * Este archivo contiene el componente GeneralForm, que representa un formulario general
 * para realizar consultas diversas.
 * 
 * El formulario recopila información como el nombre, el primer apellido, el segundo apellido, la razón social,
 * la placa, la licencia y el plástico.
 * 
 * Una vez que se completa el formulario y se envía, se realiza una llamada al endpoint del backend
 * '/api/general' para enviar la información ingresada. Luego, el componente espera la respuesta
 * del backend y llama a la función setForm para actualizar el estado con los resultados obtenidos.
 */

// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';
import {useNavigate } from "react-router-dom";

// Definición del componente funcional GeneralForm
const GeneralForm = ({  isActive }) => {
  // Definir estados locales para cada campo del formulario
  const [nombre, setNombre] = useState('');
  const [primerApellido, setPrimerApellido] = useState('');
  const [segundoApellido, setSegundoApellido] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [placa, setPlaca] = useState('');
  const [licencia, setLicencia] = useState('');
  const [plastico, setPlastico] = useState('');
  const navigate = useNavigate() 

  // Función para manejar el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    const url1 = `/busqueda-general?nombre=${nombre}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}&razonSocial=${razonSocial}&licencia=${licencia}&placa=${placa}&plastico=${plastico}`
    navigate(url1)

 
   
  }

  // Si isActive es false, no renderizar el formulario
  if (!isActive) {
    return null;
  }

  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre:
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Primer Apellido:
          <input type="text" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Segundo Apellido:
          <input type="text" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Razón Social:
          <input type="text" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Placa:
          <input type="text" value={placa} onChange={(e) => setPlaca(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Licencia:
          <input type="text" value={licencia} onChange={(e) => setLicencia(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Plastico:
          <input type="text" value={plastico} onChange={(e) => setPlastico(e.target.value)} />
        </label>
      </div>
      {/* Botón de envío del formulario */}
      <button className='button2' type="submit">Buscar</button>
    </form>
  );
};

// Exportar el componente GeneralForm
export default GeneralForm;
